import { cx } from "@linaria/core";
import { styled } from "@linaria/react";
import type { ModalProps } from "antd";
import { Modal as AntdModal } from "antd";
import { CircleX } from "lucide-react";
import type { FC } from "react";

import type { Layout } from "./constants";
import { MODAL_LAYOUT_CLASS_NAMES } from "./constants";
import { fullScreenModalClassName } from "./styles";

const StyledModal = styled(AntdModal)<ModalProps & { layout?: Layout }>`
  .ant6-modal-close {
    top: ${({ layout }) => (layout === "compact" ? "8px" : "12px")};
  }
`;

type ModalType = FC<ModalProps & { fullScreen?: boolean; layout?: Layout }> & {
  warning: typeof AntdModal.warning;
};

const Modal: ModalType = ({ layout = "default", className, width, ...props }) => {
  const isFullScreen = layout === "fullScreen";

  return (
    <StyledModal
      className={cx(isFullScreen && fullScreenModalClassName, className)}
      classNames={MODAL_LAYOUT_CLASS_NAMES[layout]}
      closeIcon={<CircleX size="1em" />}
      layout={layout}
      width={isFullScreen ? "100vw" : width}
      {...props}
    />
  );
};

Modal.warning = AntdModal.warning;

export default Modal;
